module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_6-cbbd2ae2.jpg";